export enum TypeNote {
    regular = 'regular',
    sinacor = 'sinacor',
}
